var exports = {
  "Q": "ReadonlyCommentBoxContainer__O_FJyP",
  "o": "centeredContent__4_I9nL",
};

module.exports = exports;
